import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        drawer: null,
        courseid: null,
        qbankquestype: null,
        questype: null,
        exam_id: null, //for Exam-live-dashboard on new page
        // program_id:null, //for Exam-live-dashboard on new page
        // program_type_id:null, //for Exam-live-dashboard on new page
        // year_id:null, //for Exam-live-dashboard on new page
        proctor_session_id: null,
        coe_proctor_dashboard_id: null,
    },

    mutations: {
        setcourseid(state, courseid) {
            state.courseid = courseid
        },
        setqbankquestype(state, qbankquestype) {
            state.qbankquestype = qbankquestype
        },
        setquestype(state, questype) {
            state.questype = questype
        },
        setexam_id(state, id) {
            state.exam_id = id
        },
        // setprogram_id(state, id) {
        //     state.program_id = id
        // },
        // setprogram_type_id(state, id) {
        //     state.program_type_id = id
        // },
        // setyear_id(state, id) {
        //     state.year_id = id
        // },
        setproctor_session_id(state, id) {
            state.proctor_session_id = id
        },
        setcoe_proctor_dashboard_id(state, id) {
            state.coe_proctor_dashboard_id = id
        },
    },
    getters: {
        courseid: state => state.courseid,
        qbankquestype: state => state.qbankquestype,
        questype: state => state.questype,
        exam_id: state => state.exam_id,
        // program_id: state => state.program_id,
        // program_type_id: state => state.program_type_id,
        // year_id: state => state.year_id,
        proctor_session_id: state => state.proctor_session_id,
        coe_proctor_dashboard_id: state => state.coe_proctor_dashboard_id
    }
});